import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as ACTION from '../constants/types/lotteryTypes';
import * as PUSH_ACTION from '../constants/types/pushTypes'

import $CACHE from '../helpers/cache.js'
import {stateStructure} from './_stateStructure.js'

const initialState = Immutable.fromJS( stateStructure.lottery );

export default function lottery( state = initialState, action ){

	let _state = state.toJS();

	switch (action.type) {
		// 推送彩种销售状态
		case PUSH_ACTION.LIVE_SALE_INFO:
		// 获取彩种销售情况
		case ACTION.GET_LOTTERY_SALEINFO:{
			_state.sale_info = action.result.data;
			_.each(_state.sale_info, function(lottery){
				if (lottery.is_selling || lottery.is_sale) {
					lottery.next_cycle = $.momentDate(lottery.saleend).unix() - $.momentDate(lottery.salestart).unix();
				}
			})
			return state.merge(_state);
		}

		// 动态获取静态静态信息
		case ACTION.GET_STATIC_METHOD_INFO:{
			// 动态部分解构，将玩法封装到一个数组中
			const cates = _.concat(..._.chain(action.result.data.labels).map((item) => item.labels ? _.concat(...item.labels) : []).value());
			const methods = _.concat(..._.chain(cates).map((item) => item.labels ? _.concat(...item.labels) : []).value());
			// 替换
			_.each(window.METHODS.static[action.extend].data_label, function(category){
				_.each(category.label, function(subCategory){
					_.each(subCategory.label, function(staticMethod){
						const dyMethod = _.find(methods, {menuid: staticMethod.menuid});
						if (dyMethod) {
							staticMethod.methoddesc = dyMethod.methoddesc;
							staticMethod.methodexample = dyMethod.methodexample;
							staticMethod.methodhelp = dyMethod.methodhelp;
							staticMethod.originalName = staticMethod.name;
							staticMethod.name = dyMethod.name;
							staticMethod.desc = dyMethod.description;
							staticMethod.show_str = dyMethod.show_str;
              if(staticMethod.defaultposition){
                staticMethod.defaultposition = dyMethod.defaultposition
              }
						}
					})
				})
			})
			// 复写静态缓存
			// $CACHE.put('method_static', window.METHODS.static, 7);
			// 接口缓存(半小时)
			$CACHE.put('static_lottery_' + action.extend, action.result.data, 0.02);
			return state.merge(_state);
		}

		// 推送最近开奖号码
		case PUSH_ACTION.LIVE_ISSUE_CODE_4_MENU:{
			_.each(action.data, function(item, key){
				let current = _.find(_state.sale_info, {lotteryid: key});
				if (!current) {return true;}
				const _item = _.isArray(item) ? item[0] : item;
				current.last_code = _item.code;
				current.last_issue = _item.issue;
				if (lotteryid == 27) {
					current.detail_code = _.chain(_item.fullcode).split(' ').chunk(4).value();
				}
			})
			return state.merge(_state);
		}
		// 根据彩种ID获取历史开奖奖期
		case ACTION.GET_LOTTERY_HISTORY:{
			if (action.extend) {
				return state;
			}
			_state.lottery_history = {
				id: action.origin.lotteryId,
				list: JSON.stringify(action.result.data)
			}
			return state.merge(_state);
		}
		// 注销用户
		case USER_ACTION.LOGOUT:{
			return initialState;
		}
		default:
      		return state;
	}
}